import { render, staticRenderFns } from "./AlumnosActions.vue?vue&type=template&id=2a4a9eb5&"
import script from "./AlumnosActions.vue?vue&type=script&lang=js&"
export * from "./AlumnosActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports